import { MenuType } from "../../Utils/Types";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import Input from '@mui/material/Input';


import Camera1 from '../../../assets/Icons/Camera White-01.png';
import Camera2 from '../../../assets/Icons/Camera Mutes-01.png';
import Mic1 from '../../../assets/Icons/Mic Muted.png';
import Mic2 from '../../../assets/Icons/Mic.png';
import Content from '../../../assets/Icons/Content.png';
import CamControl from '../../../assets/Icons/CamControl.png';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import CallEndIcon from '@mui/icons-material/CallEnd';
import BackSpace from '../../../assets/Icons/Erase White-01.png';
import Plus from '../../../assets/Icons/Plus-01.png';
import Minus from '../../../assets/Icons/Minus-01.png';
import ArrowIcon from "../../../assets/Icons/Arrow Up-01.png";
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import ArrowLeftIcon from '../../../assets/Icons/Arrow-left.png';
import ArrowRightIcon from '../../../assets/Icons/Arrow-right.png';
import ArrowUpIcon from '../../../assets/Icons/Arrow Up-01.png';
import ArrowDownIcon from '../../../assets/Icons/Arrow-down.png';

export const Icons = {
    Camera1,
    Camera2,
    Mic1,
    Mic2,
    Content,
    CamControl,
    LocalPhoneIcon,
    CallEndIcon,
    BackSpace,
    Plus,
    Minus,
    ArrowIcon,
    PanoramaFishEyeIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ArrowDownIcon

}
export const menu: MenuType[] = [{ id: 1, name: "Videoconference" }, { id: 2, name: "Audio Call" }]
export const remoteControls = ["Zoom", "Zoom", "Foucs", "Focus"]
export const cardData = [
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
    {
        time: "11:00 AM - 1:00 PM",
        content: "Discussing a project with a new product development team and executives",
        name: "Warren Buffet"
    },
]

export const FabStyles = [
    {
        position: 'absolute',
        bottom: "5%",
        right: "65%",
        backgroundColor: "#3E3E3E",

    },
    {
        position: 'absolute',
        bottom: "5%",
        right: "50%",
        backgroundColor: "#3E3E3E",
    },
    {
        position: 'absolute',
        bottom: "5%",
        right: "35%",
        backgroundColor: "#3E3E3E",
    },
    {
        position: 'absolute',
        bottom: "5%",
        right: "20%",
        backgroundColor: "#3E3E3E",
    },

];

export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#212121',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: {
        width: 384,
    },
    [theme.breakpoints.down("md")]: {
        width: 384,
    },
    [theme.breakpoints.down("sm")]: {
        width: 304,
    },
    height: 495,
    borderRadius: "15px"
}));

export const ButtonItem = styled(Button)(({ theme }) => ({
    color: "#909090",
    fontSize: 16,
    fontWeight: 400,
    textTransform: "capitalize",
    ":active": {
        color: "#E7F011"
    }

}))

export const CardItem = styled(Paper)(({ theme }) => ({
    borderRadius: "15px",
    backgroundColor: '#212121',
    height: 194,
    width: 303,
    marginRight: "28px",
    display: "grid",
    justifyItems: "start",
    alignItems: "center",
    marginBottom: 20

}))

export const BoxStyle = (theme: any) => {
    return {
        [theme.breakpoints.only('ip')]: {
            width: '650px'
        },
        [theme.breakpoints.only('pp')]: {
            width: '290px',

        },
        [theme.breakpoints.down('sm')]: {
            width: '290px',

        },
    }
}

export const DailerButton = styled(Button)(({ theme }) => ({
    width: 145,
    height: 85,
    borderRadius: "15px",
    backgroundColor: "#3E3E3E",
    fontWeight: 400,
    fontSize: 30,
    color: "#FFFFFF",
    marginBottom: 20,
    [theme.breakpoints.only('pp')]: {
        width: 80,

    },
    [theme.breakpoints.down('sm')]: {
        width: 80,

    },

}))
export const DailerIconButton = (theme: any) => {
    return {
        backgroundColor: "#2ED23E",
        width: 145,
        height: 85,
        borderRadius: "15px",
        [theme.breakpoints.only('pp')]: {
            width: 70,

        },
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            width: 70,

        },
    }

}
export const DailerGrid = (theme: any) => {
    return {
        marginRight: 4,
        [theme.breakpoints.only('pp')]: {
            marginRight: 3,

        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 3,

        },
    }

}
export const ControlButton = styled(Button)(({ theme }) => ({
    width: 102.5,
    height: 102.5,
    borderRadius: "15px",
    backgroundColor: "#3E3E3E",
    fontWeight: 400,
    fontSize: 36,
    color: "#FFFFFF",
    marginBottom: 15,
    ":focus": {
        backgroundColor: "#2ED23E",
    },
    [theme.breakpoints.only('pp')]: {
        width: 70,
        height: 70,
    },
    [theme.breakpoints.down('sm')]: {
        width: 70,
        height: 70,
    }
}))

export const PhoneNumberInput = styled(Input)(({ theme }) => ({
    color: "#FFFFFF",
    fontSize: 36,
    fontWeight: 400,
    textAlign: "center",
    [theme.breakpoints.only('pp')]: {
        fontSize: 23

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: 23

    },

}))

export const remoteIconButtonsStyle = (theme: any) => {
    return {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        [theme.breakpoints.only('pp')]: {
            flexDirection: "row",
            justifyContent: "space-between"
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: "row",
            justifyContent: "space-between"
        }
    }
}
export const centerArrowRemoteicon = (theme: any) => {
    return {
        width: 130,
        height: 130,
        [theme.breakpoints.only('pp')]: {
            width: 104,
            height: 104,
        },
        [theme.breakpoints.down('sm')]: {
            width: 90,
            height: 90,
        }
    }
}

